import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDeleteAccessGroupById } from "../../../hooks/common/mutation";

interface DeleteAccessGroupModalProps {
  accessGroupId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteAccessGroupModal = ({
  accessGroupId,
  isOpen,
  onOpenChange,
}: DeleteAccessGroupModalProps) => {
  const {
    mutateAsync: DeleteAccessGroupById,
    isPending: isDeleteAccessGroupByIdLoading,
  } = useDeleteAccessGroupById();

  const { t } = useTranslation();

  const handleDeleteAccessGroup = useCallback(async () => {
    try {
      const body = {
        encryptedId: accessGroupId.toString(),
      };

      await DeleteAccessGroupById(body);
      toast.success(t("accessGroupDeleted"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    } finally {
      onOpenChange();
    }
  }, [accessGroupId, DeleteAccessGroupById, t, onOpenChange]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteAccessGroup")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteAccessGroup}
            isLoading={isDeleteAccessGroupByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteAccessGroupModal);
